import React from 'react';
import { Facebook, Instagram, Youtube, ExternalLink } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
const socials = [{
  name: 'TikTok',
  url: 'https://tiktok.com/@rhinoman046',
  icon: ExternalLink,
  color: 'hover:border-[#00f2fe] hover:shadow-[0_0_15px_rgba(0,242,254,0.2)]'
}, {
  name: 'Facebook',
  url: 'https://facebook.com/Rhinoman60',
  icon: Facebook,
  color: 'hover:border-[#1877F2] hover:shadow-[0_0_15px_rgba(24,119,242,0.2)]'
}, {
  name: 'Instagram',
  url: 'https://instagram.com/Rhinoman1960',
  icon: Instagram,
  color: 'hover:border-[#E1306C] hover:shadow-[0_0_15px_rgba(225,48,108,0.2)]'
}, {
  name: 'YouTube',
  url: 'https://youtube.com/@rhinostrong2025',
  icon: Youtube,
  color: 'hover:border-[#FF0000] hover:shadow-[0_0_15px_rgba(255,0,0,0.2)]'
}];
export function SocialsSection() {
  return <section id="socials" className="py-24 bg-rhino-charcoal relative border-t border-rhino-grey" data-id="element-146">
      <div className="container mx-auto px-6" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <FadeIn data-id="element-149">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-4" data-id="element-150">
              FOLLOW THE JOURNEY
            </h2>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-151">
            <p className="text-gray-400 text-lg" data-id="element-152">
              Stay connected and get daily motivation.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto" data-id="element-153">
          {socials.map((social, index) => <FadeIn key={social.name} delay={0.2 + index * 0.1} data-id="element-154">
              <motion.a href={social.url} target="_blank" rel="noopener noreferrer" whileHover={{
            y: -5
          }} className={`flex flex-col items-center justify-center p-8 bg-rhino-black rounded-sm border border-rhino-grey transition-all duration-300 group ${social.color}`} data-id="element-155">
                <social.icon className="w-10 h-10 text-gray-400 group-hover:text-white mb-4 transition-colors" data-id="element-156" />
                <span className="font-heading font-bold text-xl text-white tracking-wider uppercase" data-id="element-157">
                  {social.name}
                </span>
                <span className="text-xs text-gray-500 mt-2 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-158">
                  Visit Profile <ExternalLink size={12} data-id="element-159" />
                </span>
              </motion.a>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}